import { useState } from "react";

import {
  Card,
  Paper,
  Stack,
  styled,
  InputBase,
  IconButton,
  CardHeader,
  Typography,
  CardActionArea,
  CircularProgress,
} from "@mui/material";

import SearchIcon from "@mui/icons-material/Search";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const ExpandMore = styled((props) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme, expand }) => ({
  padding: 4,
  transform: !expand ? "rotate(0deg)" : "rotate(180deg)",
  marginLeft: "auto",
  transition: theme.transitions.create("transform", {
    duration: theme.transitions.duration.shortest,
  }),
}));

export default function SearchAddress({ changeCenter }) {
  const [expanded, setExpanded] = useState(false);
  const [loading, setLoading] = useState(false);
  const [address, setAddress] = useState("");
  const [data, setData] = useState([]);

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  const searchFunction = () => {
    setLoading(true);
    var url = `https://map.ir/search/v2?&text=${address}`;
    fetch(url, {
      headers: {
        "Content-Type": "application/json",
        "x-api-key":
          "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6ImM1MzU3MDkxMDE3M2MwYjAzNGM1YmFjNGI2NzEwMDg2MmU3YTQ1Mjk4MThkOWViZTNkYWQ3NGYxNTMyM2M0MzRhYjNiNjMwYjI5OGVhMDgzIn0.eyJhdWQiOiI0NzY4IiwianRpIjoiYzUzNTcwOTEwMTczYzBiMDM0YzViYWM0YjY3MTAwODYyZTdhNDUyOTgxOGQ5ZWJlM2RhZDc0ZjE1MzIzYzQzNGFiM2I2MzBiMjk4ZWEwODMiLCJpYXQiOjE2NDEyMjE2NzUsIm5iZiI6MTY0MTIyMTY3NSwiZXhwIjoxNjQxMzk0NDc1LCJzdWIiOiIiLCJzY29wZXMiOlsiYmFzaWMiXX0.Ikf45Qtzp2ZgmvNfW2tckRx9SsuJOJzAdldlD9xcclSjMdGh39MpLlHTiBGswwWiQ9GvrX9emppLLXYSy68jaEgAY-KwvAESPR3t1-s7c4QSrckjuUZwV2Y_yo8dn8oGNwRPF7Ff6a6dut8GloW3VZ3qpoSi_U2JofSje54LeCiWjRc9mwDCm1T4AhKkCgxI0gKX8IuxBBZtVZmaKrv24vEriZiPMBGLUrY4AzTHfcFvCgrGTys-0u-bmeG71rLyCUmV_b8C2MNwxt2IvEgLlB9OydUYjjm-B3jVoRCiCrMcF5b9e6Ty1Zr6ARmgj1rPJmVVbKoK015teTEEd0FfMg",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setLoading(false);
        if (data?.value) {
          setData(data.value);
          setExpanded(true);
        }
      });
  };

  const handleChange = (event) => {
    setAddress(event.target.value);
    searchFunction();
  };

  const handleSelect = (data) => {
    changeCenter(data);
    setExpanded(false);
  };

  return (
    <Paper
      elevation={0}
      sx={{
        p: 0.5,
        height: 40,
        borderRadius: 1,
        width: "100%",
        display: "flex",
        alignItems: "center",
        position: "relative",
      }}
    >
      <IconButton sx={{ p: "4px" }}>
        <SearchIcon />
      </IconButton>
      <InputBase
        sx={{ flex: 1, color: "text.secondary" }}
        placeholder="جستجوی محل..."
        inputProps={{ "aria-label": "جستجوی محل..." }}
        value={address}
        onChange={handleChange}
      />
      {loading ? (
        <IconButton
          disabled
          color="primary"
          sx={{ p: "4px" }}
          aria-label="directions"
        >
          <CircularProgress size={20} />
        </IconButton>
      ) : (
        <ExpandMore
          expand={expanded}
          onClick={handleExpandClick}
          aria-expanded={expanded}
          aria-label="show more"
        >
          <ExpandMoreIcon fontSize="small" />
        </ExpandMore>
      )}
      {expanded && (
        <Stack
          rowGap={0.25}
          sx={{
            top: 44,
            left: 0,
            right: 0,
            zIndex: 100,
            position: "absolute",
          }}
          overflow="scroll"
        >
          {data.slice(0, 5).map((item, i) => (
            <Card key={i}>
              <CardActionArea
                onClick={() => handleSelect(item.geom.coordinates)}
              >
                <CardHeader
                  title={
                    <Typography variant="subtitle1" fontSize={14}>
                      {item.title}
                    </Typography>
                  }
                  subheader={
                    <Typography
                      fontSize={10}
                      variant="subtitle2"
                      color="text.secondary"
                    >
                      {item.address}
                    </Typography>
                  }
                  action={
                    <Typography variant="caption" fontSize={8}>
                      {item.county}
                    </Typography>
                  }
                  sx={{ px: 1, py: 0.5 }}
                />
              </CardActionArea>
            </Card>
          ))}
        </Stack>
      )}
    </Paper>
  );
}
